import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border,width }) {
  return (
    <Wrapper
      className="animate pointer radius6"
      onClick={action ? () => action() : null}
      border={border}
      width={width}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#954F37")};
  font-size: 1.1rem;
  background-color: ${(props) => (props.border ? "transparent" : "#954F37")};
  width: 100%;
  padding: 10px 15px;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#7f432e")};
    border: 1px solid #7f432e;
    color: ${(props) => (props.border ? "#954F37" : "#fff")};
  }
  max-width: ${(props) => (props.width ? props.width : "200px")};
`;

